import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { Dealer } from "src/app/shared/models/Dealer.model";
import { Store } from "src/app/shared/models/store";
import { User, UserVenue } from "src/app/shared/models/user.model";

@Component({
	selector: "app-user-venue-setup",
	templateUrl: "./user-venue-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class UserVenueSetupComponent implements OnInit {
	@Input() user: User;
	@Output() userChange = new EventEmitter<User>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Input() dealerList: Dealer[];
	@Output() dealerListChange = new EventEmitter<Dealer[]>();

	@Input() venueSelectionsAvailable: any[];
	@Output() venueSelectionsAvailableChange = new EventEmitter<any[]>();

	userSelectedVenues: number[];
	userSelectedVenueCount: number;

	venues: Store[];
	constructor(public app: AppService, public userService: UserService, private focuslink: FocuslinkService, private localStorage: LocalDataStoreService) {}

	ngOnInit(): void {
		if (!this.user.unsaved) {
			this.userSelectedVenues = this.user.UserVenue.map((i) => i.venueKey);
			this.userSelectedVenueCount = this.userSelectedVenues.length;
		}
	}

	compileUserSelectedVenues() {
		if (this.userSelectedVenues.length > 0) {
			for (let venue of this.userSelectedVenues) {
				let existingVenue;
				if (this.user.UserVenue && this.user.UserVenue.length > 0) {
					existingVenue = this.user.UserVenue.find((i) => i.venueKey === venue);
				} else {
					this.user.UserVenue = [];
				}

				if (!existingVenue) {
					this.user.UserVenue.push(new UserVenue({ userKey: this.user.key, venueKey: venue }));
				}
			}
		}
		this.userChange.emit(this.user);
	}
}
